import React from "react";
import { isSpUiMutationsDisabled } from "helpers/RolesPermission";
import { useSelector } from "react-redux";
import { getUser } from "store/selector/auth.selector";

const useGracePeriodOverHook = () => {
  const currentUser = useSelector(getUser);

  return isSpUiMutationsDisabled(currentUser);
};

export default useGracePeriodOverHook;
